import { FC } from 'react';

import { useRouter } from 'next/router';

import { SellingContract } from '@recoil_iqfu/atoms/iqfu_pro/searchQuery';

import RequestInfoMapButton from './request_info_map_button/RequestInfoMapButton';
import RequestShowDetailButton from './request_show_detail_button/RequestShowDetailButton';
import styles from './SellingContractActionArea.module.scss';

const SellingContractActionArea: FC<{ sellingContract: SellingContract }> = ({ sellingContract }) => {
  const router = useRouter();
  //urlがiqfu_proを含むかどうか
  const showCardAction = router.asPath.includes('iqfu_pro');
  return (
    <>
      {showCardAction && (
        <div className={`${styles.contract_action_area}`}>
          <RequestShowDetailButton
            sellingContractId={sellingContract.id}
            isActive={!!sellingContract.detail_availability}
          />
          <RequestInfoMapButton
            sellingContractId={sellingContract.id}
            hasMap={sellingContract.has_information_map && !!sellingContract.detail_availability}
          />
        </div>
      )}
    </>
  );
};

export default SellingContractActionArea;
